import React from 'react';
import { connect } from 'react-redux';
import { getUser } from 'reducers';

import styles from './index.module.css';
import default_avi from './default_avi.svg';

import SubscriptionList from 'subscriptions/SubscriptionList';

import Box from 'common/Box';
import CurrentDue from 'billing/CurrentDue';
import { formatMdn } from 'helpers/formatters';
import DaysLeft from '../../common/DaysLeft';
// import Button from 'forms/FormButton'
// import Link from 'common/Link';
// import * as routes from 'app/routes';

export const Home = ({ user }) => {
  if (!user) {
    return null;
  }

  return (
    <div className="Home">
      <Box className={styles.userCard}>
        <img className={styles.avi} alt="Avitar" src={
          user.profile_image ?
            user.profile_image :
            default_avi
        } />
        <h2 className={styles.account_name}>
          {user.first_name} {user.last_name}
        </h2>
        <div className={styles.account_phone}>
          {formatMdn(user.phone_number)}
        </div>
        <div className={styles.user_id}>
          User ID: {user && user.id}
        </div>
        <DaysLeft />
      </Box>
      <SubscriptionList subStatuses={['active', 'suspended']} showSuspendedLabel />
      <CurrentDue />
      {/*<div className={styles.orderSim}>*/}
      {/*  <h4> SIM </h4>*/}
      {/*  <Link className={styles.orderSimLink} to={routes.orderSim()}>*/}
      {/*    <Button> Order SIM </Button>*/}
      {/*  </Link>*/}
      {/*</div>*/}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: getUser(state),
});

export default connect(
  mapStateToProps
)(Home);
